import { Location } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LogoutService } from '../../../modules/auth/components/auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
	@Input() showBackButton: boolean | undefined;
	@Input() showBackButtonBlack: boolean | undefined
	@Input() headerTitle = ''
	@Input() showPageRoute=''
	@Input() status = ''
	// @Input() userPic='';
	firstName: any;
	user: any = {};
	userCreatedAt: any;
	email: any;
	@Input() isPreview: boolean | undefined;
	@Input() programId: any;
	@Output() closeProgramModalEvent = new EventEmitter();

	constructor(
		private location: Location,
		private router: Router,
		private logoutService: LogoutService
	) {
		this.getUser();
	}

	async ngOnInit() {
		await this.getUserFromCollection();
		// console.log(this.user.userPic)
		// console.log(this.showBackButton)
		this.firstName = localStorage.getItem('firstName');
		// console.log('userPic', )
		// console.log('firstName', this.firstName);
	}

	getUser() {
		this.email = localStorage.getItem('username');
		// this.userName = localStorage.getItem('firstName');
	}

	goBack() {
		this.location.back();
	}

	async getUserFromCollection() {
		const userData = await this.logoutService.getUserByEmail(this.email);
		this.user = userData[0];
		// console.log(this.user);
		if (this.user?.createdAt) {
			if (this.user.createdAt.toDate) {
				this.userCreatedAt = this.user.createdAt.toDate().toUTCString();
			} else {
				this.userCreatedAt = new Date(this.user.createdAt).toUTCString();
			}
		} else {
			this.userCreatedAt = new Date().toUTCString();
		}
	}
}